/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import {
  Title,
  Loading,
  IconButtonDatatable,
  TableCellDefault,
  TableHeader,
  DatatablesFooterServerSide,
  ModalDeleteConfirm,
} from "App/Component/ui";
import { STYLE_DEFAULT_MASTER } from "App/constants/theme";
import {
  FormTemplate,
  RESET_STATE_TEMPLATE,
  RESET_STATE_FILTER_TEMPLATE,
  FormFilterTemplate,
  getByFilterTemplate,
  headCells,
  getItemByTemplateID,
  deleteTemplateById,
} from "./ui";
import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  scrollToTop,
} from "App/utils/helpers";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";

export default function Template() {
  return (
    <div>
      <Title title={"Template"} />
      <ListTemplate />
    </div>
  );
}

export const ListTemplate = ({
  withForm = true,
  onlySelect = false,
  onlyUnit = false,
  handleClickSelect,
}) => {
  const classes = STYLE_DEFAULT_MASTER();
  const [templateID, setTemplateID] = useState("");

  const [formData, setFormData] = useState(RESET_STATE_TEMPLATE);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FILTER_TEMPLATE);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const formReset = () => {
    setFormData(RESET_STATE_TEMPLATE);
    setTemplateID("");
  };

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);
    const res = await getByFilterTemplate(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  useEffect(() => {
    if (!onlySelect) {
      setNewData();
    }
  }, []);

  const handleClickUpdate = async (row) => {
    const barang = await getItemByTemplateID(
      "/master/template/listItemBarang",
      row.id
    );
    const jasa = await getItemByTemplateID(
      "/master/template/listItemJasa",
      row.id
    );

    const fasilitas = await getItemByTemplateID(
      "/master/template/listItemFasilitas",
      row.id
    );

    const rikjang = await getItemByTemplateID(
      "/master/template/listItemRikjang",
      row.id
    );

    setTemplateID(row.id);
    setFormData({
      nama: row.nama,
      unit_id: row.id_unit,
      unit_name: row.nama_unit,
      status: row.status,
      barang: barang.data,
      jasa: jasa.data,
      fasilitas: fasilitas.data,
      rikjang: rikjang.data,
    });

    scrollToTop();
  };

  async function deleteList() {
    const res = await deleteTemplateById(templateID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
      setTemplateID("");
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const handleClickDelete = (row) => {
    setTemplateID(row.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {withForm && (
        <FormTemplate
          formData={formData}
          setFormData={setFormData}
          templateID={templateID}
          formReset={formReset}
          setTemplateID={setTemplateID}
          setNewData={setNewData}
        />
      )}

      <div className={`${withForm ? "mt-2" : ""}`}>
        <Paper className={classes.paper}>
          <Loading show={loading} />
          <FormFilterTemplate
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            onlyUnit={onlyUnit}
          />

          <TableTemplate
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
            onlySelect={onlySelect}
            handleClickSelect={handleClickSelect}
            formFilter={formFilter}
          />

          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
};

export const TableTemplate = ({
  rows,
  classes,
  onlySelect = false,
  handleClickDelete,
  handleClickUpdate,
  handleClickSelect,
  formFilter,
}) => {
  const { order, orderBy, handleRequestSort } = useDatatables({
    rows: rows,
    orderByDefault: "nama",
    orderByRow: ["nama"],
  });

  return (
    <TableContainer className='custom-scrollbar'>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={rows.length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width={"5%"}
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  width={"10%"}
                  padding='none'
                  align='center'>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "7px",
                    }}>
                    {onlySelect ? (
                      <IconButtonDatatable
                        onClick={() => handleClickSelect(row, formFilter)}>
                        <SelectIcon />
                      </IconButtonDatatable>
                    ) : (
                      <>
                        <IconButtonDatatable
                          onClick={() => handleClickUpdate(row)}>
                          <PencilIcon />
                        </IconButtonDatatable>

                        <IconButtonDatatable
                          onClick={() => handleClickDelete(row)}>
                          <TrashIcon />
                        </IconButtonDatatable>
                      </>
                    )}
                  </div>
                </TableCell>

                <TableCell align='left'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.nama}</TableCell>
                <TableCell align='left'>{row?.nama_unit}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
